export default "__VITE_ASSET__COd_08nI__"